import { render, staticRenderFns } from "./ReminderPlanTable.vue?vue&type=template&id=20b0b6f8&"
import script from "./ReminderPlanTable.vue?vue&type=script&lang=js&"
export * from "./ReminderPlanTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports